"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// bump to reset local storage for everyone
const STORE_VERSION = 10;
exports.default = {
    // jwt
    auth: null,
    // application variables
    // variables: null,
    // loads asap if jwt is present
    me: {
        id: null,
        firstName: null,
        lastName: null,
        name: null,
        email: null,
        notificationPreferences: null,
        acl: {},
    },
    // me.workspaces
    workspaces: [],
    // active workspace id
    workspaceId: null,
    // active organization id
    organizationId: null,
    // common for all pages and requests
    loading: [],
    success: [],
    errors: [],
    fresh: {
        positions: [],
    },
    industries: [],
    positions: [],
    templates: [],
    shifts: [],
    availabilities: [],
    timeOffs: [],
    offers: [],
    workspaceEvents: [],
    holidays: [],
    notifications: [],
    tasks: [],
    reply: null,
    workspaceStats: null,
    myRole: null,
    shiftDetail: null,
    // potential candidates for a new
    // shift we're creating at the moment
    dummyShiftCandidates: null,
    locale: null,
    // either estimated from IP or real
    location: null,
    exportToken: null,
    // details about each employee - indexed by employee's ID
    employees: {},
    // full user info about one employee
    employeeDetail: null,
    cycleDetail: {
        data: [],
        calendar: {},
        lastSavedCycleShift: null,
    },
    // component/sidebar
    sidebar: null,
    // component/modal
    modal: null,
    // calendar-related
    calendar: null,
    calendarMultiSelect: {
        action: null,
        sourceEvents: [],
        targets: [],
        isActive: false,
        isSelectingTargets: false,
    },
    calendarSearch: {
        query: '',
        results: [],
    },
    calendarFilters: [],
    tablesConfig: {},
    enforcedLocality: null,
    // bump to reset local storage for everyone
    version: STORE_VERSION,
    // show/hide admin panel
    showAdminPanel: false,
    // Create news feed
    newsFeed: {},
    //  Announce Shift
    announceShifts: {
        announce: [],
        known: [],
        periodStart: '',
        periodEnd: '',
    },
    organization: {
        members: [],
        roles: [],
        countries: [],
        positions: [],
        hidden: null,
        settings: null,
    },
    // attendance
    // attendance: {
    //   attendance: [],
    //   config: {
    //     initial: true,
    //     view: {
    //       type: '',
    //       layout: '',
    //       info: {
    //         period: {
    //           end: '',
    //           start: '',
    //         },
    //         actualMonth: {
    //           period: {
    //             end: '',
    //             start: '',
    //           },
    //           currentDay: '',
    //         },
    //         daysNmb: null,
    //         year: '',
    //         monthDate: '',
    //         date: '',
    //       },
    //       loader: false,
    //     },
    //   },
    //   allStats: {
    //     plan: null,
    //     reality: null,
    //     inWork: null,
    //     overTime: null,
    //     confirmed: null,
    //     unavailabilityTime: null,
    //     pauseDuration: null,
    //   },
    //   attendanceByDays: [],
    //   attendanceDetails: {
    //     events: [],
    //     name: '',
    //     attendanceStats: {
    //       plan: null,
    //       reality: null,
    //       inWork: null,
    //       overTime: null,
    //       confirmed: null,
    //       unavailabilityTime: null,
    //       pauseDuration: null,
    //     },
    //     day: '',
    //     employeeId: null,
    //   },
    // },
    chat: {
        unread: 0,
    },
    // onboarding checklist state per workspace id — see app/reducer/onboarding.ts
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    onboarding: {},
    // what the manager currently has on screen, published by pages for the assistant to
    // read — see app/reducer/ui-context.ts. Never persisted.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    uiContext: { onboarding: undefined },
    // manager dashboard (/dashboard). Keyed by the workspace and day the payload was fetched
    // for, so the page refetches on a workspace switch or a day rollover. Never persisted.
    dashboard: {
        key: null,
        data: null,
        isLoading: false,
        hasError: false,
        // the day overview's rows, fetched by their own operation so that filtering the table
        // does not drop the four metrics back to a skeleton
        dayOverview: {
            key: null,
            data: null,
            toleranceMinutes: null,
            isLoading: false,
            hasError: false,
        },
    },
    // workspace terminals — kept in the store rather than in the dashboard page because
    // installing the terminal plugin remounts that page. Never persisted.
    terminals: {
        workspaceId: null,
        list: null,
        isLoading: false,
    },
    // manager assistant column (right side of the screen, all manager pages)
    managerAssistant: {
        // collapsed by default so the column never appears unannounced; persisted, so
        // once a manager expands it, it stays expanded across reloads and navigation
        expanded: false,
        // auto-planner panel in the top half of the column. Replaces what the open/closed
        // state of the old right-side 'planning' sidebar used to mean, so it is NOT derived
        // from currentPlan.status — the replan flow deletes the plan while the panel stays up.
        planningOpen: false,
        // a message another page asked the assistant to start a new chat with (a dashboard
        // alert's "Resolve with Daysie"). The chat sends it and clears it. Never persisted.
        seedPrompt: undefined,
        // when the agent's last reply finished — a signal: the dashboard reloads its alerts
        // whenever it changes. A timestamp, not a counter, because the persisted slice is only
        // `{ expanded }` after a reload, and `undefined + 1` is NaN. Never persisted.
        lastReplyAt: null,
    },
};
